import { assert_type_boolean, not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__token } from '../token/DTO__token';

export abstract class DTO_GENERATION_SETTING__base extends DTO__base {
  /*
   * STATIC METHODS
   */
  static get_unique(array: DTO__token[]): DTO__token[];
  static get_unique(array: DTO_GENERATION_SETTING__base[]): DTO_GENERATION_SETTING__base[] {
    return array.filter((item1, index, self) => index === self.findIndex(item2 => item2.is_equal(item1)));
  }

  /*
   * FIELDS
   */
  is_hidden: boolean;

  /*
   * METHODS
   */

  constructor(is_hidden: boolean = false) {
    super();
    this.is_hidden = is_hidden;
  }

  is_equal(other: DTO_GENERATION_SETTING__base): boolean {
    not_implemented_type(this.constructor.name);
    return false;
  }

  /*
   * ASSERTS
   */
  assert_standard_fields(): void {
    assert_type_boolean(this.is_hidden);
  }
}
